/** student/roles — KEYS. */
export const studentRolesKeys = {
  all: () => ['student', 'roles'] as const,
};
